import { setup } from '~/core'
setup()

import '~/global/_body'
import '~/global/_header'
import '~/global/_footer'
import '~/global/_siteModals'

import '~/components/_accordion'
import '~/components/_decade'
import '~/components/_forms'
import '~/components/_locationFinder'
import '~/components/_productInfo'
import '~/components/_testimonial'
import '~/components/_selectbox'

import '~/search/_main'

import '~/vendor/bootstrap/modal.js'
